module.exports = __webpack_public_path__ + "static/details-9-724d54cc03cf3393a8e2c4e0a35cf575.jpg";